import type { ComponentProps } from 'react';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSquareFull } from '@rtkwlf/pro-solid-svg-icons/faSquareFull';

export interface FontAwesomeGradientIconProps {
  icon: ComponentProps<typeof FontAwesomeIcon>['icon'];
  size: ComponentProps<typeof FontAwesomeIcon>['size'];
  /** Pass css variable to change icon mask color.
   * @default --aw-palette-promo-iconGradient
   */
  iconGradient?: string;
  /** Pass css variable to change icon mask color.
   * @default --aw-palette-background-default
   */
  iconMaskColor?: string;
}

// TODO: @evagm: move to separate component to be reusable
export const FontAwesomeGradientIcon = ({
  icon,
  iconGradient,
  iconMaskColor,
  size,
}: FontAwesomeGradientIconProps) => (
  <FontAwesomeIcon
    icon={icon}
    size={size}
    color={`var(${iconMaskColor ?? '--aw-palette-background-default'})`}
    mask={faSquareFull}
    style={{
      padding: 0,
      margin: '3px', // need to be a margin instead of padding to prevent a border from being added.
      background: `var(${iconGradient ?? '--aw-palette-promo-iconGradient'})`,
    }}
  />
);
